import formNames from '../../../constants/formNames';

const formName = formNames.company;

export const DUPLICATE_COMPANY = `${formName}/DUPLICATE_COMPANY`;
